<template>
  <trumbowyg v-model="content" ref="editor" :config="config"></trumbowyg>
</template>

<script>
export default {
  props: {
    value: { type: String, default: "" },
  },
  data() {
    return {
      content: this.value,
      config: {
        btns: [
          ["viewHTML"],
        //   ["undo", "redo"],
          ["formatting"],
          ["bold", "italic", "underline"],
        //   ["superscript", "subscript"],
          ["link"],
        //   ["base64"],
          ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
          ["unorderedList", "orderedList"],
        //   ["horizontalRule"],
        //   ["removeformat"],
          ["fullscreen"],
        ],
        plugins: {
          base64: {},
          undo: {},
          redo: {},
          resizeimg: { step: 1 },
        },
      },
    };
  },
  watch: {
    value(newVal) {
      if (newVal !== this.content) this.content = newVal;
    },
    content(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>
